@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.select {
  position: relative;

  svg {
    display: block;
  }

  .singleValue {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 0 0 14px;
    gap: 8px;
    min-width: 0;
    overflow: hidden;

    .valueLabel {
      @include t.text(14px, 22px, 400);
      color: v.$palette-gray-900;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
      flex: 1 1 auto;
    }

    .valueIcon {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
      flex-shrink: 0;
      color: v.$palette-gray-900;

      svg path {
        fill: currentColor;
      }
    }
  }

  .multiValue {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 14px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
  }

  .placeholder {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 16px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-600;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .input {
    display: flex;
    align-items: center;
    height: 43px;
    padding: 0 16px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
    flex-shrink: 0;

    &.isMulti {
      position: relative;
      display: inline-grid;
      height: auto;
    }

    &.isMulti.isNonEmpty {
      padding: 0;
    }
  }

  .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    padding: 8px 16px;
    gap: 8px;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;

    &.isSelected {
      background: v.$palette-gray-100;
    }

    &.isFocused {
      background: v.$palette-blue-light-2;
    }

    &.isSelected.isFocused {
      background: v.$palette-gray-100;
    }

    .valueLabel {
      @include t.text(14px, 22px, 400);
      color: v.$palette-gray-900;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .valueIcon {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
      color: v.$palette-gray-900;

      // svg path {
      //   fill: currentColor;
      // }
    }


    .textWrap {
      display: flex;
      gap: 8px;
      overflow: hidden;
      color: v.$palette-gray-900;

      // svg path {
      //   fill: currentColor;
      // }
    }

    // CheckIcon sits next to .textWrap
    > svg {
      color: v.$palette-gray-900;
      flex-shrink: 0;
    }
  }

  .dropDownIndicator {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    color: v.$palette-gray-900;

    svg path {
      fill: currentColor;
    }
  }
  
  .menuListContainer {
    padding: 4px;
  }

  @keyframes selectFadeIn {
    0% {
      max-height: 0;
      opacity: 0;
      transform: translateY(-20px);
    }
    25% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      max-height: 150px;
      opacity: 1;
      transform: translateY(0);
    }
  }

  .menu {
    z-index: v.$z-index-select-dropdown;
    animation: selectFadeIn 300ms ease-in-out;
    @include c.custom-scrollbar();
    overflow: hidden;
  }

  .menuRelative {
    position: relative;
    top: auto;
    left: auto;
  }


  :global {
    [id$="-live-region"],
    [class*="-a11yText"] {
      @include c.visually-hidden;
    }

    .react-select {
      &__control {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        height: 48px;
        border-radius: 8px;
        background: v.$palette-white;
        border: 1px solid v.$palette-gray-400;
        min-width: 0;
      }

      &__indicators {
        display: flex;
        align-items: center;
        align-self: stretch;
        flex-shrink: 0;
      }

      &__input-container {
        grid-area: 1 / 2;
        margin: 0;
        padding-left: 16px;
      }

      &__value-container {
        display: grid;
        align-items: center;
        flex: 1;
        padding: 0;
        margin: 0;
        min-width: 0;
        overflow: hidden;
        position: relative;

        > input {
          background: transparent;
          border: 0;
          caret-color: transparent;
          color: transparent;
          font-size: inherit;
          grid-area: 1 / 1 / 2 / 3;
          height: 1px;
          opacity: 0;
          outline: 0;
          padding: 0;
          position: absolute;
          transform: scale(0.01);
          width: 1px;
        }
      }

      &__single-value,
      &__placeholder {
        grid-area: 1 / 1 / 2 / 3;
        max-width: 100%;
        overflow: hidden;
      }

      &__dropdown-indicator {
        transform: rotate(180deg);
        padding: 0;
        color: v.$palette-gray-900;
      }

      &__control--is-focused {
        box-shadow: none;
        border-color: v.$palette-gray-400;
      }

      &__control--menu-is-open,
      &__control--menu-is-open.react-select__control--is-focused {
        box-shadow: v.$shadow-3;
        border-color: v.$palette-blue;
      }

      &__control--is-disabled {
        cursor: not-allowed;
        background: v.$palette-gray-100;
        opacity: 0.6;
      }

      &__indicator-separator {
        display: none;
      }

      &__option {
        padding: 0;
        background: none;

        &:active {
          background: none;
        }
      }

      &__menu {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        border-radius: 8px;
        background: v.$palette-white;
        box-shadow: v.$shadow-2;
      }

      &__menu-list {
        padding: 0;
        border: none;
        background: v.$palette-white;
        box-shadow: v.$shadow-2;
      }
    }

    .react-select__control--menu-is-open .react-select__dropdown-indicator {
      transform: rotate(0deg);
    }
  }
}

.menuRelative:global(.react-select__menu) {
  position: relative;
  top: auto;
  left: auto;
}

.notSearchable {
  :global {
    .react-select__input-container,
    .react-select__value-container > input {
      @include c.visually-hidden;
      background: transparent;
      border: 0;
      margin: 0;
      padding: 0;
    }
  }
}

